import { cloneDeep } from 'lodash'
import _forEach from 'lodash/forEach'
import { isCompositeComponent } from 'react-dom/test-utils'
import {
  call,
  cancel,
  cancelled,
  delay,
  fork,
  put,
  select,
  take,
} from 'redux-saga/effects'

import { IPFS_URL } from '../../app/constants'
import { setUserCollection } from '../../features/collection/userCollectionSlice'
import { RequestUserCollection } from '../requests/requestUserCollection'

export function* collectionAPI() {
  const data = yield select()
  const user = data.user.userAccount.accountName

  return new Promise(async (resolve, reject) => {
    try {
      const collection = await RequestUserCollection(user)
      resolve(collection)
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveCollection() {
  try {
    const collectionData = yield call(collectionAPI)
    const { data } = yield collectionData
    const collection = data.data
    const info = yield select()
    const userCollection = cloneDeep(info.galaktikaCollection.collections)
    // const getUserCollection = () => {
    //   try {
    //     const data = JSON.parse(JSON.stringify(collections));
    //     return data;
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };

    // const userCollection = getUserCollection();
    const rarities = [
      'GoldStorm',
      'Supernova',
      'Unicorn',
      'Luminaya',
      'Plasma',
      'Chromium',
      'Beskar',
      'Meteorite',
      'Titanium',
    ]

    let cards = {}
    let fullCollection = []

    // Create Collection Object for Mission with Individual Cards - Used in Missions

    collection.forEach((card) => {
      return (fullCollection = [
        ...fullCollection,
        {
          cardTemplateId: card.template.template_id,
          uniqueId: card.asset_id,
          series: card.data.series ?? '',
          rarity: card.data.rarity ?? '',
          name: card.name ?? '',
          image: card.data.img ? card.data.img : '',
          video: card.data.video ? card.data.video : '',
          mint: card.template_mint,
          mp: '',
        },
      ])
    })

    // Loop through the whole user Collection and add one to each rarity of the Collection from the Galaktika Server for each card the user has in their wallet  - Used on Collection Page

    let totalMP = 0

    // ONLY WORKS ON MAINNET - TESTNET uses different templates and will throw an error

    if (userCollection) {
      const getCollectionItems = () => {
        console.log('collection item:', collection)
        collection.forEach((element) => {
          if (element.data.class === 'Civilization') {
            if (userCollection.Civilizations) {
              if (element.data.rarity) {
                userCollection.Civilizations[element.data.series][element.name][
                  element.data.rarity
                ].quantity =
                  userCollection.Civilizations[element.data.series][
                    element.name
                  ][element.data.rarity].quantity + 1

                totalMP =
                  totalMP +
                  userCollection.Civilizations[element.data.series][
                    element.name
                  ][element.data.rarity].mp

                // Add the MP value to the full Collection with individual Cards - used in Missions
                fullCollection.forEach((card, i) => {
                  if (
                    userCollection.Civilizations[element.data.series][
                      element.name
                    ][element.data.rarity].template_id === card.cardTemplateId
                  ) {
                    fullCollection[i] = {
                      ...card,
                      mp: userCollection.Civilizations[element.data.series][
                        element.name
                      ][element.data.rarity].mp,
                    }
                  }
                })
              } else if (element.data.class === 'Spark') {
                userCollection.Others[element.name].quantity =
                  userCollection.Others[element.name].quantity + 1
                totalMP = totalMP + userCollection.Others[element.name].mp
                // Add the MP value to the full Collection with individual Cards - used in Missions
                fullCollection.forEach((card, i) => {
                  if (
                    userCollection.Others[element.name].template_id ===
                    card.cardTemplateId
                  ) {
                    fullCollection[i] = {
                      ...card,
                      mp: userCollection.Others[element.name].mp,
                    }
                  }
                })
              } else if (element.data.class === 'Krystal') {
                userCollection.Krystals[element.name].no_rarity.quantity =
                  userCollection.Krystals[element.name].no_rarity.quantity + 1
                totalMP =
                  totalMP + userCollection.Krystals[element.name].no_rarity.mp
                // Add the MP value to the full Collection with individual Cards - used in Missions
                fullCollection.forEach((card, i) => {
                  if (
                    userCollection.Krystals[element.name].no_rarity
                      .template_id === card.cardTemplateId
                  ) {
                    fullCollection[i] = {
                      ...card,
                      mp: userCollection.Krystals[element.name].no_rarity.mp,
                    }
                  }
                })
              } else {
                console.log(element)
              }
            }
          } else if (!element.data.class && !element.data.rarity) {
            userCollection.Others[element.name].quantity =
              userCollection.Others[element.name].quantity + 1
            totalMP = totalMP + userCollection.Others[element.name].mp
            // Add the MP value to the full Collection with individual Cards - used in Missions
            fullCollection.forEach((card, i) => {
              if (
                userCollection.Others[element.name].template_id ===
                card.cardTemplateId
              ) {
                fullCollection[i] = {
                  ...card,
                  mp: userCollection.Others[element.name].mp,
                }
              }
            })
          } else {
            console.log(element)
          }
        })
      }

      getCollectionItems()

      const setUserCards = () => {
        if (userCollection) {
          _forEach(userCollection, function (collection, type) {
            return (cards = { ...cards, [type]: [] })
          })

          _forEach(
            userCollection.Civilizations,
            function (collection, civilisation) {
              return (cards.Civilizations = {
                ...cards.Civilizations,
                [civilisation]: [],
              })
            },
          )
        }

        _forEach(
          userCollection.Civilizations,
          function (collection, civilisation) {
            _forEach(
              userCollection.Civilizations[civilisation],
              function (cardInfo, cardName) {
                for (let i = 0; i < rarities.length; i++) {
                  if (
                    cardInfo[rarities[i]] &&
                    cardInfo[rarities[i]].quantity > 0
                  ) {
                    if (cardInfo[rarities[i]].image) {
                      cards.Civilizations[civilisation].push({
                        name: cardName,
                        info: cardInfo,
                        bestRarity: rarities[i],
                        image: `${IPFS_URL}${cardInfo[rarities[i]].image}`,
                      })
                      return
                    } else {
                      cards.Civilizations[civilisation].push({
                        name: cardName,
                        info: cardInfo,
                        bestRarity: rarities[i],
                        video: `${IPFS_URL}${cardInfo[rarities[i]].video}`,
                      })
                      return
                    }
                    // Looping through all the card rarities, then looping through the last two (as a precaution in case one of them doesn't have data) in case the cards are not in the user wallet
                  } else if (i === 8) {
                    if (cardInfo[rarities[i]]) {
                      if (cardInfo[rarities[i]].image) {
                        cards.Civilizations[civilisation].push({
                          name: cardName,
                          info: cardInfo,
                          image: `${IPFS_URL}${cardInfo[rarities[i]].image}`,
                          notInUserWallet: true,
                        })
                        return
                      } else {
                        cards.Civilizations[civilisation].push({
                          name: cardName,
                          info: cardInfo,
                          video: `${IPFS_URL}${cardInfo[rarities[i]].video}`,
                          notInUserWallet: true,
                        })
                        return
                      }
                    } else if (cardInfo[rarities[7]]) {
                      if (cardInfo[rarities[7]].image) {
                        cards.Civilizations[civilisation].push({
                          name: cardName,
                          info: cardInfo,
                          image: `${IPFS_URL}${cardInfo[rarities[7]].image}`,
                          notInUserWallet: true,
                        })
                        return
                      } else {
                        cards.Civilizations[civilisation].push({
                          name: cardName,
                          info: cardInfo,
                          video: `${IPFS_URL}${cardInfo[rarities[7]].video}`,
                          notInUserWallet: true,
                        })
                        return
                      }
                    }
                  }
                }
              },
            )
          },
        )
        return (cards = {
          ...cards,
          Krystals: userCollection.Krystals,
          Others: userCollection.Others,
        })
      }

      setUserCards()
    }

    yield put(
      setUserCollection({
        type: 'FETCHING_SUCCESS',
        collections: cards,
        fullCollection,
        totalMP,
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setUserCollection({ type: 'FETCHING_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setUserCollection({ type: 'FETCHING_CANCELLED' }))
    }
  }
}

export function* collectionFlow() {
  const info = yield select()
  while (true) {
    if (info.galaktikaCollection.status === 'FETCHING_SUCCESS') {
      console.log('HELLO!!!!!!')
      yield put(setUserCollection({ type: 'GET_COLLECTION' }))
      const task = yield fork(resolveCollection)
      const action = yield take(['FETCHING_ERROR'])
      if (action.type === 'STOP_FETCHING') {
        yield cancel(task)
      }
    } else {
      for (let i = 0; i < 5; i++) {
        yield delay(5000, setUserCollection({ type: 'GET_COLLECTION' }))
        yield fork(resolveCollection)
        if (i === 4) {
          console.log('The Galaktika Server is Down')
        }
      }
    }
  }
}
